import { render, staticRenderFns } from "./goodsListzd.vue?vue&type=template&id=e3dabfb0&scoped=true"
import script from "./goodsListzd.vue?vue&type=script&lang=js"
export * from "./goodsListzd.vue?vue&type=script&lang=js"
import style0 from "./goodsListzd.vue?vue&type=style&index=0&id=e3dabfb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3dabfb0",
  null
  
)

export default component.exports